import {
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
} from '@mui/material';
import { useRootStore } from '../../../../stores/rootStore';

const COUNTRY_OF_BIRTH_METRICS_AU = [
  {
    groupMetricId: '102',
    metricId: '1046',
    displayName: 'Country of Birth: Australia',
    definition:
      'The percentage breakdown of residents born in Australia in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1047',
    displayName: 'Country of Birth: Canada',
    definition:
      'The percentage breakdown of residents born in Canada in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1048',
    displayName: "Country of Birth: China, People's Republic of",
    definition:
      'The percentage breakdown of residents born in China in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1049',
    displayName: 'Country of Birth: Croatia',
    definition:
      'The percentage breakdown of residents born in Croatia in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1050',
    displayName: 'Country of Birth: Egypt',
    definition:
      'The percentage breakdown of residents born in Egypt in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1051',
    displayName: 'Country of Birth: Fiji',
    definition:
      'The percentage breakdown of residents born in Fiji in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1052',
    displayName: 'Country of Birth: France',
    definition:
      'The percentage breakdown of residents born in France in the geographical area. This metric is available for 2016 and 2021.',
  },
  {
    metricId: '1053',
    displayName: 'Country of Birth: Germany',
    definition:
      'The percentage breakdown of residents born in Germany in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1054',
    displayName: 'Country of Birth: Greece',
    definition:
      'The percentage breakdown of residents born in Greece in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1055',
    displayName: 'Country of Birth: Hong Kong (Special Administrative Region)',
    definition:
      'The percentage breakdown of residents born in Hong Kong in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1056',
    displayName: 'Country of Birth: India',
    definition:
      'The percentage breakdown of residents born in India in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1057',
    displayName: 'Country of Birth: Indonesia',
    definition:
      'The percentage breakdown of residents born in Indonesia in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1058',
    displayName: 'Country of Birth: Ireland',
    definition:
      'The percentage breakdown of residents born in Ireland in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1059',
    displayName: 'Country of Birth: Italy',
    definition:
      'The percentage breakdown of residents born in Italy in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1060',
    displayName: 'Country of Birth: Korea, Republic of',
    definition:
      'The percentage breakdown of residents born in Korea in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1061',
    displayName: 'Country of Birth: Lebanon',
    definition:
      'The percentage breakdown of residents born in Lebanon in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1062',
    displayName: 'Country of Birth: Macedonia',
    definition:
      'The percentage breakdown of residents born in Macedonia in the geographical area. This metric is available for 2006, 2011, and 2016.',
  },
  {
    metricId: '1063',
    displayName: 'Country of Birth: Malaysia',
    definition:
      'The percentage breakdown of residents born in Malaysia in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1064',
    displayName: 'Country of Birth: Malta',
    definition:
      'The percentage breakdown of residents born in Malta in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1065',
    displayName: 'Country of Birth: Netherlands',
    definition:
      'The percentage breakdown of residents born in Netherlands in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1066',
    displayName: 'Country of Birth: New Zealand',
    definition:
      'The percentage breakdown of residents born in New Zealand in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1067',
    displayName: 'Country of Birth: Philippines',
    definition:
      'The percentage breakdown of residents born in Philippines in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1068',
    displayName: 'Country of Birth: Poland',
    definition:
      'The percentage breakdown of residents born in Poland in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1069',
    displayName: 'Country of Birth: Singapore',
    definition:
      'The percentage breakdown of residents born in Singapore in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1070',
    displayName: 'Country of Birth: South Africa',
    definition:
      'The percentage breakdown of residents born in South Africa in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1071',
    displayName: 'Country of Birth: Sri Lanka',
    definition:
      'The percentage breakdown of residents born in Sri Lanka in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1072',
    displayName: 'Country of Birth: Turkey',
    definition:
      'The percentage breakdown of residents born in Turkey in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1073',
    displayName: 'Country of Birth: United Kingdom (not further defined)',
    definition:
      'The percentage breakdown of residents born in UK in the geographical area. This metric is available for 2006, and 2011.',
  },
  {
    metricId: '1074',
    displayName: 'Country of Birth: United States of America',
    definition:
      'The percentage breakdown of residents born in USA in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1075',
    displayName: 'Country of Birth: Viet Nam',
    definition:
      'The percentage breakdown of residents born in Vietnam in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1076',
    displayName: 'Country of Birth: Southern and Eastern Europe',
    definition:
      'The percentage breakdown of residents born in Southern and Eastern Europe in the geographical area. This metric is available for 2006, 2011, and 2016.',
  },
  {
    metricId: '1077',
    displayName: 'Country of Birth: Born Elsewhere',
    definition:
      'The percentage breakdown of residents born elsewhere in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1279',
    displayName: 'Country of Birth: Afghanistan',
    definition:
      'The percentage breakdown of residents born in Afganistan in the geographical area. This metric is available for 2016 and 2021.',
  },
  {
    metricId: '1280',
    displayName: 'Country of Birth: Bangladesh',
    definition:
      'The percentage breakdown of residents born in Bangladesh in the geographical area. This metric is available for 2016 and 2021.',
  },
  {
    metricId: '1281',
    displayName: 'Country of Birth: Bosnia and Herzegovina',
    definition:
      'The percentage breakdown of residents born in Bosnia and Herzegovina in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1282',
    displayName: 'Country of Birth: Cambodia',
    definition:
      'The percentage breakdown of residents born in Cambodia in the geographical area. This metric is available for 2011, 2016, and 2021.',
  },
  {
    metricId: '1283',
    displayName: 'Country of Birth: Chile',
    definition:
      'The percentage breakdown of residents born in Chile in the geographical area. This metric is available for 2016 and 2021.',
  },
  {
    metricId: '1284',
    displayName: 'Country of Birth: England',
    definition:
      'The percentage breakdown of residents born in England in the geographical area. This metric is available for 2016 and 2021.',
  },
  {
    metricId: '1285',
    displayName: 'Country of Birth: Mauritius',
    definition:
      'The percentage breakdown of residents born in Mauritius in the geographical area. This metric is available for 2016 and 2021.',
  },
  {
    metricId: '1286',
    displayName: 'Country of Birth: Iran',
    definition:
      'The percentage breakdown of residents born in Iran in the geographical area. This metric is available for 2016 and 2021.',
  },
  {
    metricId: '1287',
    displayName: 'Country of Birth: Iraq',
    definition:
      'The percentage breakdown of residents born in Iraq in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1288',
    displayName: 'Country of Birth: Japan',
    definition:
      'The percentage breakdown of residents born in Japan in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1289',
    displayName: 'Country of Birth: Myanmar',
    definition:
      'The percentage breakdown of residents born in Myanmar in the geographical area. This metric is available for 2016 and 2021.',
  },
  {
    metricId: '1290',
    displayName: 'Country of Birth: Nepal',
    definition:
      'The percentage breakdown of residents born in Nepal in the geographical area. This metric is available for 2016 and 2021.',
  },
  {
    metricId: '1291',
    displayName: 'Country of Birth: Northern Ireland',
    definition:
      'The percentage breakdown of residents born in Northern Ireland in the geographical area. This metric is available for 2016.',
  },
  {
    metricId: '1292',
    displayName: 'Country of Birth: Not Stated',
    definition:
      'The percentage breakdown of residents who did Not State where they were born. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1293',
    displayName: 'Country of Birth: Pakistan',
    definition:
      'The percentage breakdown of residents born in Pakistan in the geographical area. This metric is available for 2016 and 2021.',
  },
  {
    metricId: '1294',
    displayName: 'Country of Birth: Papua New Guinea',
    definition:
      'The percentage breakdown of residents born in Papua New Guinea in the geographical area. This metric is available for 2006, 2016, and 2021.',
  },
  {
    metricId: '1295',
    displayName: 'Country of Birth: Scotland',
    definition:
      'The percentage breakdown of residents born in Scotland in the geographical area. This metric is available for 2016 and 2021.',
  },
  {
    metricId: '1296',
    displayName: 'Country of Birth: Taiwan',
    definition:
      'The percentage breakdown of residents born in Taiwan in the geographical area. This metric is available for 2016 and 2021.',
  },
  {
    metricId: '1297',
    displayName: 'Country of Birth: Thailand',
    definition:
      'The percentage breakdown of residents born in Thailand in the geographical area. This metric is available for 2006, 2011, 2016, and 2021.',
  },
  {
    metricId: '1298',
    displayName: 'Country of Birth: Wales',
    definition:
      'The percentage breakdown of residents born in Wales in the geographical area. This metric is available for 2016 and 2021.',
  },
  {
    metricId: '1299',
    displayName: 'Country of Birth: Zimbabwe',
    definition:
      'The percentage breakdown of residents born in Zimbabwe in the geographical area. This metric is available for 2016 and 2021.',
  },
  {
    metricId: '1355',
    displayName: 'Country of Birth: North Macedonia',
    definition:
      'The percentage breakdown of residents born in North Macedonia in the geographical area. This metric is available for 2021.',
  },
  {
    metricId: '1356',
    displayName: 'Country of Birth: Samoa',
    definition:
      'The percentage breakdown of residents born in Samoa in the geographical area. This metric is available for 2021.',
  },
  {
    metricId: '1357',
    displayName: 'Country of Birth: Brazil',
    definition:
      'The percentage breakdown of residents born in Brazil in the geographical area. This metric is available for 2021.',
  },
];

const COUNTRY_OF_BIRTH_METRICS_NZ = [
  {
    groupMetricId: '102',
    metricId: '1046',
    displayName: 'Country of Birth: Australia',
    definition:
      'The percentage breakdown of residents born in Australia in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1047',
    displayName: 'Country of Birth: Canada',
    definition:
      'The percentage breakdown of residents born in Canada in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1048',
    displayName: "Country of Birth: China, People's Republic of",
    definition:
      'The percentage breakdown of residents born in China in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1049',
    displayName: 'Country of Birth: Croatia',
    definition:
      'The percentage breakdown of residents born in Croatia in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1050',
    displayName: 'Country of Birth: Egypt',
    definition:
      'The percentage breakdown of residents born in Egypt in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1051',
    displayName: 'Country of Birth: Fiji',
    definition:
      'The percentage breakdown of residents born in Fiji in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1052',
    displayName: 'Country of Birth: France',
    definition:
      'The percentage breakdown of residents born in France in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1053',
    displayName: 'Country of Birth: Germany',
    definition:
      'The percentage breakdown of residents born in Germany in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1054',
    displayName: 'Country of Birth: Greece',
    definition:
      'The percentage breakdown of residents born in Greece in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1055',
    displayName: 'Country of Birth: Hong Kong (Special Administrative Region)',
    definition:
      'The percentage breakdown of residents born in Hong Kong in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1056',
    displayName: 'Country of Birth: India',
    definition:
      'The percentage breakdown of residents born in India in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1057',
    displayName: 'Country of Birth: Indonesia',
    definition:
      'The percentage breakdown of residents born in Indonesia in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1058',
    displayName: 'Country of Birth: Ireland',
    definition:
      'The percentage breakdown of residents born in Ireland in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1059',
    displayName: 'Country of Birth: Italy',
    definition:
      'The percentage breakdown of residents born in Italy in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1060',
    displayName: 'Country of Birth: Korea, Republic of',
    definition:
      'The percentage breakdown of residents born in Korea in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1062',
    displayName: 'Country of Birth: Macedonia',
    definition:
      'The percentage breakdown of residents born in Macedonia in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1063',
    displayName: 'Country of Birth: Malaysia',
    definition:
      'The percentage breakdown of residents born in Malaysia in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1065',
    displayName: 'Country of Birth: Netherlands',
    definition:
      'The percentage breakdown of residents born in Netherlands in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1066',
    displayName: 'Country of Birth: New Zealand',
    definition:
      'The percentage breakdown of residents born in New Zealand in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1067',
    displayName: 'Country of Birth: Philippines',
    definition:
      'The percentage breakdown of residents born in Philippines in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1068',
    displayName: 'Country of Birth: Poland',
    definition:
      'The percentage breakdown of residents born in Poland in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1069',
    displayName: 'Country of Birth: Singapore',
    definition:
      'The percentage breakdown of residents born in Singapore in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1070',
    displayName: 'Country of Birth: South Africa',
    definition:
      'The percentage breakdown of residents born in South Africa in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1071',
    displayName: 'Country of Birth: Sri Lanka',
    definition:
      'The percentage breakdown of residents born in Sri Lanka in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1072',
    displayName: 'Country of Birth: Turkey',
    definition:
      'The percentage breakdown of residents born in Turkey in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1073',
    displayName: 'Country of Birth: United Kingdom (not further defined)',
    definition:
      'The percentage breakdown of residents born in UK in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1074',
    displayName: 'Country of Birth: United States of America',
    definition:
      'The percentage breakdown of residents born in USA in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1075',
    displayName: 'Country of Birth: Viet Nam',
    definition:
      'The percentage breakdown of residents born in Vietnam in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1076',
    displayName: 'Country of Birth: Southern and Eastern Europe',
    definition:
      'The percentage breakdown of residents born in Southern and Eastern Europe in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1279',
    displayName: 'Country of Birth: Afghanistan',
    definition:
      'The percentage breakdown of residents born in Afganistan in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1280',
    displayName: 'Country of Birth: Bangladesh',
    definition:
      'The percentage breakdown of residents born in Bangladesh in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1282',
    displayName: 'Country of Birth: Cambodia',
    definition:
      'The percentage breakdown of residents born in Cambodia in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1283',
    displayName: 'Country of Birth: Chile',
    definition:
      'The percentage breakdown of residents born in Chile in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1284',
    displayName: 'Country of Birth: England',
    definition:
      'The percentage breakdown of residents born in England in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1286',
    displayName: 'Country of Birth: Iran',
    definition:
      'The percentage breakdown of residents born in Iran in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1287',
    displayName: 'Country of Birth: Iraq',
    definition:
      'The percentage breakdown of residents born in Iraq in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1288',
    displayName: 'Country of Birth: Japan',
    definition:
      'The percentage breakdown of residents born in Japan in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1289',
    displayName: 'Country of Birth: Myanmar',
    definition:
      'The percentage breakdown of residents born in Myanmar in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1290',
    displayName: 'Country of Birth: Nepal',
    definition:
      'The percentage breakdown of residents born in Nepal in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1291',
    displayName: 'Country of Birth: Northern Ireland',
    definition:
      'The percentage breakdown of residents born in Northern Ireland in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1292',
    displayName: 'Country of Birth: Not Stated',
    definition:
      'The percentage breakdown of residents who did Not State where they were born. This metric is available for 2023.',
  },
  {
    metricId: '1293',
    displayName: 'Country of Birth: Pakistan',
    definition:
      'The percentage breakdown of residents born in Pakistan in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1294',
    displayName: 'Country of Birth: Papua New Guinea',
    definition:
      'The percentage breakdown of residents born in Papua New Guinea in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1295',
    displayName: 'Country of Birth: Scotland',
    definition:
      'The percentage breakdown of residents born in Scotland in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1296',
    displayName: 'Country of Birth: Taiwan',
    definition:
      'The percentage breakdown of residents born in Taiwan in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1297',
    displayName: 'Country of Birth: Thailand',
    definition:
      'The percentage breakdown of residents born in Thailand in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1298',
    displayName: 'Country of Birth: Wales',
    definition:
      'The percentage breakdown of residents born in Wales in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1299',
    displayName: 'Country of Birth: Zimbabwe',
    definition:
      'The percentage breakdown of residents born in Zimbabwe in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1356',
    displayName: 'Country of Birth: Samoa',
    definition:
      'The percentage breakdown of residents born in Samoa in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1357',
    displayName: 'Country of Birth: Brazil',
    definition:
      'The percentage breakdown of residents born in Brazil in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1358',
    displayName: 'Country of Birth: Argentina',
    definition:
      'The percentage breakdown of residents born in Argentina in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1359',
    displayName: 'Country of Birth: At sea',
    definition:
      'The percentage breakdown of residents born in At sea in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1360',
    displayName: 'Country of Birth: Austria',
    definition:
      'The percentage breakdown of residents born in Austria in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1361',
    displayName: 'Country of Birth: Belgium',
    definition:
      'The percentage breakdown of residents born in Belgium in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1362',
    displayName: 'Country of Birth: Channel Islands',
    definition:
      'The percentage breakdown of residents born in Channel Islands in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1363',
    displayName: 'Country of Birth: Colombia',
    definition:
      'The percentage breakdown of residents born in Colombia in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1364',
    displayName: 'Country of Birth: Cook Islands',
    definition:
      'The percentage breakdown of residents born in Cook Islands in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1365',
    displayName: 'Country of Birth: Czech Republic',
    definition:
      'The percentage breakdown of residents born in Czech Republic in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1366',
    displayName: 'Country of Birth: Denmark',
    definition:
      'The percentage breakdown of residents born in Denmark in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1367',
    displayName: 'Country of Birth: Ethiopia',
    definition:
      'The percentage breakdown of residents born in Ethiopia in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1368',
    displayName: 'Country of Birth: Hungary',
    definition:
      'The percentage breakdown of residents born in Hungary in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1369',
    displayName: 'Country of Birth: Israel',
    definition:
      'The percentage breakdown of residents born in Israel in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1370',
    displayName: 'Country of Birth: Kenya',
    definition:
      'The percentage breakdown of residents born in Kenya in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1371',
    displayName: 'Country of Birth: Kiribati',
    definition:
      'The percentage breakdown of residents born in Kiribati in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1372',
    displayName: 'Country of Birth: Mexico',
    definition:
      'The percentage breakdown of residents born in Mexico in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1373',
    displayName: 'Country of Birth: Niue',
    definition:
      'The percentage breakdown of residents born in Niue in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1374',
    displayName: 'Country of Birth: North Africa and the Middle East',
    definition:
      'The percentage breakdown of residents born in North Africa and the Middle East in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1375',
    displayName: 'Country of Birth: North-East Asia',
    definition:
      'The percentage breakdown of residents born in North-East Asia in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1376',
    displayName: 'Country of Birth: North-West Europe',
    definition:
      'The percentage breakdown of residents born in North-West Europe in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1377',
    displayName: 'Country of Birth: Other Americas',
    definition:
      'The percentage breakdown of residents born in Other Americas in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1378',
    displayName: 'Country of Birth: Other Oceania and Antarctica',
    definition:
      'The percentage breakdown of residents born in Other Oceania and Antarctica in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1379',
    displayName: 'Country of Birth: Other Sub-Saharan Africa',
    definition:
      'The percentage breakdown of residents born in Other Sub-Saharan Africa in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1380',
    displayName: 'Country of Birth: Overseas',
    definition:
      'The percentage breakdown of residents born in Overseas in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1381',
    displayName: 'Country of Birth: Pacific Islands',
    definition:
      'The percentage breakdown of residents born in Pacific Islands in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1382',
    displayName: 'Country of Birth: Romania',
    definition:
      'The percentage breakdown of residents born in Romania in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1383',
    displayName: 'Country of Birth: Russia',
    definition:
      'The percentage breakdown of residents born in Russia in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1384',
    displayName: 'Country of Birth: Saudi Arabia',
    definition:
      'The percentage breakdown of residents born in Saudi Arabia in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1385',
    displayName: 'Country of Birth: Serbia',
    definition:
      'The percentage breakdown of residents born in Serbia in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1386',
    displayName: 'Country of Birth: Solomon Islands',
    definition:
      'The percentage breakdown of residents born in Solomon Islands in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1387',
    displayName: 'Country of Birth: Somalia',
    definition:
      'The percentage breakdown of residents born in Somalia in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1388',
    displayName: 'Country of Birth: South-East Asia',
    definition:
      'The percentage breakdown of residents born in South-East Asia in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1389',
    displayName: 'Country of Birth: Southern and Central Asia',
    definition:
      'The percentage breakdown of residents born in Southern and Central Asia in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1390',
    displayName: 'Country of Birth: Spain',
    definition:
      'The percentage breakdown of residents born in Spain in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1391',
    displayName: 'Country of Birth: Sub-Saharan Africa',
    definition:
      'The percentage breakdown of residents born in Sub-Saharan Africa in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1392',
    displayName: 'Country of Birth: Sweden',
    definition:
      'The percentage breakdown of residents born in Sweden in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1393',
    displayName: 'Country of Birth: Switzerland',
    definition:
      'The percentage breakdown of residents born in Switzerland in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1394',
    displayName: 'Country of Birth: Syria',
    definition:
      'The percentage breakdown of residents born in Syria in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1395',
    displayName: 'Country of Birth: The Americas',
    definition:
      'The percentage breakdown of residents born in The Americas in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1396',
    displayName: 'Country of Birth: Tokelau',
    definition:
      'The percentage breakdown of residents born in Tokelau in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1397',
    displayName: 'Country of Birth: Tonga',
    definition:
      'The percentage breakdown of residents born in Tonga in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1398',
    displayName: 'Country of Birth: Tuvalu',
    definition:
      'The percentage breakdown of residents born in Tuvalu in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1399',
    displayName: 'Country of Birth: Ukraine',
    definition:
      'The percentage breakdown of residents born in Ukraine in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1400',
    displayName: 'Country of Birth: United Arab Emirates',
    definition:
      'The percentage breakdown of residents born in United Arab Emirates in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1401',
    displayName: 'Country of Birth: Vanuatu',
    definition:
      'The percentage breakdown of residents born in Vanuatu in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1402',
    displayName: 'Country of Birth: Zambia',
    definition:
      'The percentage breakdown of residents born in Zambia in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1450',
    displayName: 'Country of Birth: Not elsewhere included',
    definition:
      'The percentage breakdown of residents born in Not elsewhere included in the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1451',
    displayName: 'Country of Birth: Other',
    definition:
      'The percentage breakdown of residents born in Other included in the geographical area. This metric is available for 2023.',
  },
];

export const CountryOfBirthMetrics = () => {
  const country = useRootStore(state => state.country);

  const metrics = [
    {
      title: 'Country Of Birth',
      data:
        country === 'au'
          ? COUNTRY_OF_BIRTH_METRICS_AU
          : COUNTRY_OF_BIRTH_METRICS_NZ,
    },
  ];

  return (
    <div>
      <Typography
        id="country-of-birth-metrics"
        variant="h6"
        fontWeight={600}
        my={0.5}
      >
        Country of Birth
      </Typography>

      <Typography variant="body2">
        The Country of Birth Metrics relate to the countries of birth for the
        residents in a particular location.
      </Typography>

      <br />

      <Stack gap={4}>
        {metrics
          .filter(metric => metric.data.length > 0)
          .map(metric => (
            <div>
              <Typography variant="body2" fontWeight={600}>
                {metric.title}
              </Typography>

              <br />

              <TableContainer component={Paper}>
                <Table>
                  <TableHead sx={{ whiteSpace: 'nowrap' }}>
                    <TableRow>
                      <TableCell>Group Metric ID</TableCell>
                      <TableCell>Metric ID</TableCell>
                      <TableCell>Display Name</TableCell>
                      <TableCell>Definition</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {metric.data.map(data => (
                      <TableRow key={data.metricId}>
                        {data.groupMetricId && (
                          <TableCell rowSpan={metric.data.length}>
                            {data.groupMetricId}
                          </TableCell>
                        )}
                        <TableCell>{data.metricId}</TableCell>
                        <TableCell>{data.displayName}</TableCell>
                        <TableCell>{data.definition}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          ))}
      </Stack>
    </div>
  );
};
